import React from "react";
import DefaultLayout from "../../components/layout/DefaultLayout";
import {
    Box,
    Button,
    Grid,
    Typography,
    Divider,
    Hidden,
    Dialog,
    DialogContent,
    DialogContentText,
    DialogActions
} from "@mui/material";
import "../../styles/pages/register.scss";
import { useTheme } from '@mui/material/styles';
import {useHistory } from "react-router-dom";


const RegisterPage = () => {
    const history = useHistory();
    const theme = useTheme();
    const [open, setOpen] = React.useState(false);
    const [showHelloMessage, setShowHelloMessage] = React.useState(false);
    const handleClickOpen = () => {
        setOpen(true);
        setShowHelloMessage(false);
    };

    const handleClose = () => {
        //setOpen(false);
        setShowHelloMessage(true);
    };

    const handleRedirect = () => {
        setOpen(false);
        history.push('/ui/register/insured')
    };

    const handleCompanyRedirect = () => {
        setOpen(false);
        history.push('/ui/register/company')
    };

    return (
        <DefaultLayout>
            <>
                <Dialog
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    sx={{ p: 3 }}
                >
                    <DialogContent>
                        {!showHelloMessage ? (
                            <>
                                <DialogContentText id="alert-dialog-description">
                                    <Typography variant="h3" component="span" sx={{ textAlign: "center", display: "block" }}>
                                        Avez-vous déjà perçu des prestations directement de la part d'Uniprévoyance ?
                                    </Typography>
                                </DialogContentText>
                            </>
                        ) : (
                            <Typography variant="h4" component="span" sx={{ textAlign: "left", display: "block" }}>
                                L'espace Mon Unip est réservé uniquement aux assurés bénéficaires de prestations.
                                <span style={{ display: 'block', marginTop: '10px' }}>
                                <a href="/ui/contact/insured" style={{ color: "#36B8C9", fontSize: "14px", fontWeight: "bold" }}>
                                  Nous Contacter
                                </a>
                              </span>
                            </Typography>

                        )}
                    </DialogContent>
                    <DialogActions sx={{ pr: 2.5 }}>
                        {!showHelloMessage ? (
                            <>
                                <Button
                                    variant="outlined"
                                    sx={{
                                        color: theme.palette.error.dark,
                                        borderColor: theme.palette.error.dark,
                                        '&:hover': {
                                            borderColor: theme.palette.error.main,
                                        },
                                    }}
                                    onClick={handleClose}
                                    color="secondary"
                                >
                                    Non
                                </Button>
                                <Button variant="contained" color="primary" size="small" onClick={handleRedirect} autoFocus>
                                    Oui
                                </Button>
                            </>
                        ) : (
                            <Button variant="contained" color="primary" onClick={() => setOpen(false)}>Close</Button>
                        )}
                    </DialogActions>
                </Dialog>
            </>
            <Box display="flex" justifyContent="center" alignItems="center"
                 sx={{
                     backgroundImage: theme.palette.mode === 'dark' ? `url(${process.env.PUBLIC_URL + "/assets/img/bg_registrer_dark.png"})` : `url(${process.env.PUBLIC_URL + "/assets/img/bg_registrer.png"})`,
                     backgroundSize: 'cover',
                     backgroundPosition: 'center'
                 }}>

                <Grid container justifyContent="center" sx={{ width: '1000px', position: 'relative' }}>
                    {/* Authentication Section */}

                    <Box className="authentification"
                         sx={{
                             textAlign: 'center',
                             position: 'absolute',
                             top: 0,
                             left: '25%',
                             transform: 'translateX(-50%)',
                             width: '100%',
                             display: { xs: 'none', sm: 'none', md: 'block' }, // Hides on extra small and small screens
                         }}>
                        <div className="group-2" >
                            <div className="frame">
                                <p className="p">Bienvenue dans votre espace client</p>
                            </div>
                            <img className="vector" src={process.env.PUBLIC_URL + "/assets/img/vector.svg"}
                                 alt="Vector"/>
                            <div className="logo">
                                <div className="overlap-group">
                                    <img className="img" src={process.env.PUBLIC_URL + "/assets/img/logoMonUnip.svg"}
                                         alt="Logo"/>
                                </div>
                            </div>
                        </div>
                    </Box>

                    <Grid item xs={12} sm={6} sx={{ marginTop: { xs: "0px", sm: "80px" } }}>
                        <Box textAlign="left" p={4}>
                            <Box
                                component="img"
                                src={process.env.PUBLIC_URL + "/assets/img/particular.svg"}
                                alt="particular"
                                sx={{
                                    width: "354px",
                                    height: "428px",
                                    marginLeft: '-80px',
                                    marginBottom: '-100px',
                                    display: {xs: 'none', sm: 'block'},
                                    top: 0,
                                    left: 0,
                                   // animation: '5s wings ease-in-out infinite',
                                    zIndex: 5,
                                }}
                            />
                            <Typography variant="h2" sx={{fontWeight: 'bold'}}>
                                Assuré
                            </Typography>
                            <Divider sx={{
                                borderColor: '#EF595D',
                                my: 1,
                                width: '20%',
                                borderWidth: '2px',
                                marginBottom: '15px',
                                marginTop: '15px'
                            }}/>
                            <Typography sx={{
                                fontSize: '16px',
                                width: '50%',
                                marginBottom: '30px',
                                display: {xs: 'none', sm: 'block'}
                            }}>
                                Vous pouvez consulter les prestations versées par Uniprévoyance, déposez une
                                demande.</Typography>

                            <Button variant="contained" color="primary" onClick={handleClickOpen} sx={{textTransform: 'none'}} >
                                Je me connecte
                            </Button>
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={6} sx={{ marginTop: { xs: "0px", sm: "80px" } }}>
                        <Box textAlign="right" p={4}>
                            <Box
                                display="flex"
                                justifyContent="flex-end" // Align the image to the right
                            >
                                <Box
                                    component="img"
                                    src={process.env.PUBLIC_URL + "/assets/img/entreprise.svg"}
                                    alt="entreprise"
                                    sx={{
                                        width: "354px",
                                        height: "428px",
                                        marginRight: '-70px',
                                        marginBottom: '-100px',
                                        display: {xs: 'none', sm: 'block'},
                                        top: 0,
                                        left: 0,
                                       // animation: '5s wings ease-in-out infinite',
                                        zIndex: 5,
                                    }}
                                />
                            </Box>
                            <Typography variant="h2" sx={{fontWeight: 'bold'}}>
                                Entreprise
                            </Typography>
                            <div style={{display: 'flex', justifyContent: 'flex-end'}}>
                                <Divider sx={{
                                    borderColor: '#EF595D',
                                    my: 1,
                                    width: '20%',
                                    borderWidth: '2px',
                                    marginBottom: '15px',
                                    marginTop: '15px',

                                }}/>
                            </div>
                            <Box
                                display="flex"
                                justifyContent="flex-end"
                                width="100%"  // Ensure it takes the full width of the parent
                            >
                                <Typography sx={{
                                    fontSize: '16px',
                                    width: '50%',
                                    textAlign: 'right',
                                    marginBottom: '30px',
                                    display: {xs: 'none', sm: 'block'}
                                }}>
                                    Consultez vos remboursements et les services dédiés à votre profil.
                                </Typography>
                            </Box>
                            <Button variant="contained" color="primary" onClick={handleCompanyRedirect} sx={{textTransform: 'none'}}>
                                Je me connecte
                            </Button>
                        </Box>
                    </Grid>
                </Grid>
            </Box>
        </DefaultLayout>
    );
};

export default RegisterPage;
